<script lang="ts">
import { createEventDispatcher } from "svelte";


    let fileinput, file, csv, message, validCsv, promise, data;
    export let username;

    const dispatcher = createEventDispatcher()

    function onUpload() {
        dispatcher("verifySession")
        file = fileinput.files[0]
        const reader = new FileReader()
        reader.addEventListener("load", () => {
            csv = reader.result
            validateCsv(csv)
        })
        reader.readAsText(file)
    }

    function filterInt(value): number | boolean {
        if(/^(\-|\+)?([0-9]+|Infinity)$/.test(value))
            return Number(value);
        return false;
    }

    const validateCsv = (csv) => {
        dispatcher("verifySession")
        let lines: Array<any> = csv.split('\n')
        message = ""
        
        lines.forEach((element, index) => {
            let values: Array<string> = element.split(';')
            if (values.length == 1 && values[0] == "" || values[0] == "Datum"){
                lines.splice(index, 2)
            }else if (!filterInt(values[0].replaceAll(".", ""))){
                console.log("Die Form wurde nicht eingehalten")
                message = "Die Form wurde nicht eingehalten"
                return false
            }else if (values.length < 2){
                console.log("Es wurden zu wenig Werte angegeben")
                message = "Es wurden zu wenig Werte angegeben"
                return false
            }else if (values.length > 3){
                console.log("Es wurden zu viele Werte angegeben")
                message = "Es wurden zu viele Werte angegeben"
                return false
            }else{
                let date: Array<string> = values[0].split(".")
                let phar1: number | boolean = filterInt(values[1])
                let phar2: number | boolean = filterInt(values[2])
                if (date.length === 3) {
                    date.forEach(element => {
                        if (parseInt(element) == NaN) {
                            console.log("Ein Wert ist kein richtiges Datum")
                            message = "Ein Wert ist kein richtiges Datum"
                            return false
                        }
                    })
                }else{
                    console.log("Ein Wert ist kein richtiges Datum")
                    message = "Ein Wert ist kein richtiges Datum"
                    return false
                }
                if (!phar1 && !phar2) {
                    console.log("Ein Wert ist keine gültige Apotheken Nummer")
                    message = "Ein Wert ist keine gültige Apotheken Nummer"
                    return false
                }
            }
        });
        if(message !== ""){validCsv = false}else{validCsv = true; promise = fetchImpotCsv(lines)}
    }

    async function fetchImpotCsv(csv){
        dispatcher("verifySession")
        let res = await fetch("/calender/importCsv", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({csv: csv, username: username})
        });
        data = await res.json()
    }

</script>

<div class="border-2 p-4 shadow">
    <div class="grid grid-cols-1 justify-items-start mb-5">
        <p class="font-bold mb-2">Beispiel CSV Format! :</p>
        <div
            class="border-l-4 border-yellow-500 rounded-r-lg shadow-xl bg-gray-100 p-3 grid grid-cols-1 mt-6 divide-y-2 divide-gray-200">
            <div class="grid grid-cols-3 bg-gray-200">
                <p class="p-1 font-bold">Datum</p>
                <p class="p-1 font-bold">Apotheken Nummer 1</p>
                <p class="p-1 font-bold">Apotheken Nummer 2</p>
            </div>
            <div class="grid grid-cols-3 pt-3">
                <p class="p-1">01.01.2021;</p>
                <p class="p-1">277;</p>
                <p class="p-1">278</p>
            </div>
            <div class="grid grid-cols-3">
                <p class="p-1">02.01.2021;</p>
                <p class="p-1">279;</p>
                <p class="p-1">280</p>
            </div>
            <div class="grid grid-cols-3">
                <p class="p-1">03.01.2021;</p>
                <p class="p-1">281;</p>
                <p class="p-1">283</p>
            </div>
            <div>...</div>
        </div>
    </div>
    <div class="grid grid-cols-1 justify-self-stretch">
        {#if validCsv === false}
        <div class="border-l-4 border-red-500 rounded-r-lg shadow-xl bg-red-100 p-3 grid grid-cols-1 mt-6 justify-self-center mb-4">
            <strong class="text-red-500">Ein Fehler ist aufgetreten</strong>
            <p class="text-red-500">{message}</p>
        </div>
        {/if}
        {#if validCsv === true}
        {#await promise}
        <div></div>
        {:then}
        {#if data.imported}
        <div class="border-l-4 border-green-500 rounded-r-lg shadow-xl bg-green-100 p-3 grid grid-cols-1 mt-6 justify-self-center mb-4">
            <strong class="text-green-500">Erfolg!</strong>
            <p class="text-green-500">CSV wurde erfolgreich eingespielt!</p>
        </div>
        {/if}
        {#if data.message}
        <div class="border-l-4 border-red-500 rounded-r-lg shadow-xl bg-red-100 p-3 grid grid-cols-1 mt-6 justify-self-center mb-4">
            <strong class="text-red-500">Ein Fehler ist aufgetreten</strong>
            <p class="text-red-500">{data.message}</p>
        </div>
        {/if}
        {/await}
        {/if}
        <div class="border-none bg-blue-500 p-2 font-bold rounded shadow-xl select-none cursor-pointer w-auto h-auto text-white justify-self-center"
            on:click="{()=>{fileinput.click();}}">Upload</div>
        <input style="display:none;" type="file" bind:this="{fileinput}" on:input="{onUpload}">
    </div>
</div>